import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/for-clinics')({
  beforeLoad: () => {
    throw redirect({ to: '/for-allied-health' });
  },
  component: () => null,
});
